import { useMemo } from "react";

export function CartIcon({ className }: { className?: string }) {
  // Generate unique gradient ID for this instance
  const gradientId = useMemo(() => `cart-gradient-${Math.random().toString(36).slice(2, 11)}`, []);
   
  return (
    <svg 
      className={className} 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M2.25 2.25C2.05109 2.25 1.86032 2.32902 1.71967 2.46967C1.57902 2.61032 1.5 2.80109 1.5 3C1.5 3.19891 1.57902 3.38968 1.71967 3.53033C1.86032 3.67098 2.05109 3.75 2.25 3.75H3.636C3.806 3.75 3.954 3.864 3.998 4.028L6.556 13.62C5.75257 13.8293 5.04126 14.2992 4.53349 14.9561C4.02573 15.613 3.75017 16.4197 3.75 17.25C3.75 17.664 4.086 18 4.5 18H20.25C20.4489 18 20.6397 17.921 20.7803 17.7803C20.921 17.6397 21 17.4489 21 17.25C21 17.0511 20.921 16.8603 20.7803 16.7197C20.6397 16.579 20.4489 16.5 20.25 16.5H5.378C5.53313 16.0612 5.82052 15.6813 6.20056 15.4127C6.5806 15.144 7.0346 14.9999 7.5 15H18.718C18.8585 15 18.9962 14.9605 19.1153 14.8861C19.2345 14.8117 19.3304 14.7053 19.392 14.579C20.5337 12.2361 21.5224 9.82171 22.352 7.351C22.3848 7.25326 22.397 7.14981 22.3881 7.04712C22.3791 6.94442 22.349 6.84468 22.2997 6.75413C22.2505 6.66357 22.1831 6.58415 22.1017 6.52081C22.0204 6.45747 21.9269 6.41158 21.827 6.386C16.5528 5.04115 11.122 4.40985 5.68 4.509L5.448 3.642C5.34156 3.24274 5.10621 2.88982 4.77853 2.6381C4.45086 2.38637 4.0492 2.24994 3.636 2.25H2.25ZM3.75 20.25C3.75 19.8522 3.90804 19.4706 4.18934 19.1893C4.47064 18.908 4.85218 18.75 5.25 18.75C5.64782 18.75 6.02936 18.908 6.31066 19.1893C6.59196 19.4706 6.75 19.8522 6.75 20.25C6.75 20.6478 6.59196 21.0294 6.31066 21.3107C6.02936 21.592 5.64782 21.75 5.25 21.75C4.85218 21.75 4.47064 21.592 4.18934 21.3107C3.90804 21.0294 3.75 20.6478 3.75 20.25ZM16.5 20.25C16.5 19.8522 16.658 19.4706 16.9393 19.1893C17.2206 18.908 17.6022 18.75 18 18.75C18.3978 18.75 18.7794 18.908 19.0607 19.1893C19.342 19.4706 19.5 19.8522 19.5 20.25C19.5 20.6478 19.342 21.0294 19.0607 21.3107C18.7794 21.592 18.3978 21.75 18 21.75C17.6022 21.75 17.2206 21.592 16.9393 21.3107C16.658 21.0294 16.5 20.6478 16.5 20.25Z" 
        fill={`url(#${gradientId})`}
      />
      <defs>
        <linearGradient 
          id={gradientId}
          x1="11.9455" 
          y1="2.25" 
          x2="11.9455" 
          y2="21.75" 
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A8E063"/>
          <stop offset="1" stopColor="#56AB2F"/>
        </linearGradient>
      </defs>
    </svg>
  )
}